import React, { useState } from 'react';
import { MANDATORY_FIELDS, STEP_KEYS } from '../shared/mandatoryFieldsData';

const TYPES = [
  { key: 'q1', label: 'Q1 — Kundenreklamation', color: 'blue' },
  { key: 'q2', label: 'Q2 — Lieferantenreklamation', color: 'amber' },
  { key: 'q3', label: 'Q3 — Werk-zu-Werk', color: 'purple' },
];

const COLORS = {
  blue: 'bg-blue-100 text-blue-800 border-blue-300',
  amber: 'bg-amber-100 text-amber-800 border-amber-300',
  purple: 'bg-purple-100 text-purple-800 border-purple-300',
};

export default function SectionReklamationErstellen() {
  const [type, setType] = useState('q1');
  const [step, setStep] = useState('d0');
  const availableSteps = STEP_KEYS.filter(s => (MANDATORY_FIELDS[type] || {})[s]);
  const fields = (MANDATORY_FIELDS[type] || {})[step] || [];

  return (
    <div className="space-y-4" data-testid="section-reklamation-erstellen">
      <div>
        <h3 className="text-base font-bold text-slate-800 mb-1">Reklamation erstellen — Vollständige Pflichtfelder</h3>
        <p className="text-xs text-slate-500">Synchron mit dem Backend-Validierungsservice. Bei fehlenden Pflichtfeldern wird der D-Schritt als unvollständig markiert.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {TYPES.map(t => (
          <button
            key={t.key}
            onClick={() => { setType(t.key); setStep('d0'); }}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold border-2 transition ${type === t.key ? COLORS[t.color] : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'}`}
            data-testid={`manual-type-${t.key}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-1.5">
        {availableSteps.map(s => (
          <button
            key={s}
            onClick={() => setStep(s)}
            className={`px-2.5 py-1 rounded text-[11px] font-mono font-bold uppercase transition ${step === s ? 'bg-slate-800 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}
            data-testid={`manual-step-${s}`}
          >{s}</button>
        ))}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs border-collapse">
          <thead>
            <tr className="bg-slate-50 border-b-2 border-slate-200">
              <th className="text-left p-2 font-semibold text-slate-700">Feld</th>
              <th className="text-left p-2 font-semibold text-slate-700">Typ</th>
              <th className="text-left p-2 font-semibold text-slate-700">Quelle / Auto-Befüllung</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((f, i) => (
              <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}>
                <td className="p-2 font-medium text-slate-800">{f.label}</td>
                <td className="p-2 text-slate-600">{f.type}</td>
                <td className="p-2 text-slate-500">{f.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3 rounded-lg bg-amber-50 border-l-4 border-amber-400 text-xs text-amber-900">
        <strong className="block mb-1">Hinweis zur Validierung:</strong>
        Fehlende Pflichtfelder blockieren den D-Schritt-Übergang. Der Quality-Gate-Service prüft nach jedem Speichern und zeigt eine rote Markierung, bis alle Felder ausgefüllt sind.
      </div>

      <div className="p-3 rounded-lg bg-blue-50 border-l-4 border-blue-400 text-xs text-blue-900">
        <strong className="block mb-1">Tipp für Auto-Befüllung:</strong>
        Viele Felder werden automatisch aus den Katalogen (Kunden, Produkte, SAP) vorbelegt, sobald Sie einen Eintrag wählen. Sie müssen nur noch validieren und ggf. anpassen.
      </div>
    </div>
  );
}
